import React, { useEffect } from 'react';
import {useHistory} from 'react-router-dom';
import '../CSS/Home.css';
import Logout from '../Images/logout.png';
import Green from '../Images/greenCircle.png';
import Red from '../Images/redCircle.png';
import Yellow from '../Images/yellowCircle.png';
import Grey from '../Images/greyCircle.png';
import IdCardIcon from '../Images/idCard.png';
import MarksIcon from '../Images/marks.png';
import AmizoneIcon from '../Images/amizone.png';
import ContactIcon from '../Images/contact.png';
import ComingSoonIcon from '../Images/comingSoon.png';
import {Button, Card} from '@material-ui/core';
import Loading from '../Components/Loading';
import { motion} from 'framer-motion';
import { pageTransition, pageStyle, pageVariants } from '../Components/Animations/Transition';
import {get24Hours, getConvertedTime, convertDate, checkTimeInterval} from '../Functions.js';
import ClassModel from '../Components/Home/ClassModel';
import NavigateButtonsModel from '../Components/Home/NavigateButtonsModel';
import {getUrl} from '../Functions.js';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';

function Home() {
  const history  = useHistory();

  const [cookie, setCookie] = React.useState(localStorage.getItem("cookie"));
  const [attendanceData, setAttendanceData] = React.useState([]);
  const [timetableData, setTimetableData] = React.useState([]);
  const [loadingAttendance, setLoadingAttendance] = React.useState(true);
  const [loadingTimetable, setLoadingTimetable] = React.useState(true);
  const [dateToday, setDateToday] = React.useState(convertDate(0));
  const [currentClass, setCurrentClass] = React.useState({});
  const [nextClass, setNextClass] = React.useState({});
  const [classStatus, setClassStatus] = React.useState(false);
  const [nextClassStatus, setNextClassStatus] = React.useState(false);
  const [openPopUp, setOpenPopUp] = React.useState(false);
  const closeModal = () => setOpenPopUp(false);
  const loadingHeight = "5vh";

   const optionsAttendance = {
    method : 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ 
      cookies:cookie
    })
  }

  const optionsTimetable = {
    method : 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ 
      cookies:cookie,
      date:dateToday
    })
  }

   function fetchData(){
    if(localStorage.getItem("loggedIn")!=="true"){
      history.push("/opening");
    }
    setTimetableData([]);
    fetch(getUrl() + 'timetable', optionsTimetable)
      .then(response => response.json()).then(
        data =>{
          if(data.retry===true){
            console.log("retrying Timetable...");
            fetchData();
          }else{
            setLoadingTimetable(false);
            setTimetableData(data.timetable);
            var tempCurrent = new Date();
            tempCurrent.setHours(tempCurrent.getHours());
            
            if(data.timetable[0].start===undefined){
              setClassStatus(false);
              setNextClassStatus(false);
            }else{
              var startOfCollegeTime = get24Hours(getConvertedTime(data.timetable[0].start));
              var endOfCollegeTime = get24Hours(getConvertedTime(data.timetable[data.timetable.length-1].end));
              var statusOfCurrentTime = checkTimeInterval(startOfCollegeTime, endOfCollegeTime, tempCurrent);
              if(statusOfCurrentTime===2){
                for(var i=0;i<data.timetable.length;i++){
                  var ele = data.timetable[i];
                  var tempStart = get24Hours(getConvertedTime(ele.start));
                  var tempEnd = get24Hours(getConvertedTime(ele.end));
                  var statusOfCurrentClass = checkTimeInterval(tempStart, tempEnd, tempCurrent);

                  if(statusOfCurrentClass===2){
                    setCurrentClass(ele);
                    setClassStatus(true);
                    if(i!==(data.timetable.length-1)){
                      setNextClass(data.timetable[i+1]);
                      setNextClassStatus(true);
                    }else{
                      setNextClassStatus(false);
                    }
                    break;
                  }

                  if(statusOfCurrentClass===1){
                    setClassStatus(false);
                    setNextClass(ele);
                    setNextClassStatus(true);
                    break;
                  }
                }
              }else if(statusOfCurrentTime==1){
                setClassStatus(false);
                setNextClass(data.timetable[0]);
                setNextClassStatus(true);
              }else{
                setClassStatus(false);
                setNextClassStatus(false);
              }
            }
            
          }
        }
      )
    fetch(getUrl() + 'attendance', optionsAttendance)
      .then(response => response.json()).then(
        data =>{
          if(data.retry===true){
            console.log("retrying Attendance...");
            fetchData();
          }else{
            setAttendanceData(data.status);
            setLoadingAttendance(false);
          }
        }
      );
  }

  function logout(){
    localStorage.setItem("loggedIn","false");
    localStorage.removeItem("details");
    localStorage.setItem("cookie","");
    history.push("/opening");
  }

  function navigate(endpoint){
    history.push("/"+endpoint)
  }

  React.useEffect(() => {
    fetchData();
  },[]);

  return (
    <motion.div className="Home"
    initial="initial"
    animate="in"
    exit="out"
    style={pageStyle}
    variants={pageVariants}
    transition={pageTransition}>
      <div className="TopHome">
        <div></div>
        <div className="LogoutHome" onClick={()=>logout()}>
          <img src={Logout} height="20px" width="20px" alt="logout" className="LogoutImageHome"/>
          LOGOUT
        </div>
      </div>

      <Popup open={openPopUp} closeOnDocumentClick onClose={closeModal} modal>
        {() => ( 
          <div className="PopUpHome">
            <img src={ComingSoonIcon} style={{
              marginBottom: "10px"
            }}/>
            Coming Soon
          </div>
        )}
      </Popup>

      <div className="MiddleHome">
        <Card
          raised
          className="TimetableHome"
          onClick={()=>navigate("timetable")}
        >
          <div
          className="TextPartHome">
            <div className="RotatedTextTimetableHome">
              Timetable
            </div>
          </div>

          <div
          className="TimetableBigHome">
            {loadingTimetable===true?<Loading height={loadingHeight} color="#ff6247" page="Home"/>:
            <div className="ClassDetailsHome">
             <ClassModel heading="Current Class" classDetails={currentClass} classStatus={classStatus} noClassMessage="No Class Now"/>
             <ClassModel heading="Next Class" classDetails={nextClass} classStatus={nextClassStatus} noClassMessage="No More Classes Today"/>
            </div>
            }

          </div>
        </Card>
        <Card
          raised
          className="AttendanceHome"
          onClick={()=>navigate("attendance")}
          >
          <div
          className="AttendanceBigHome">
            {loadingAttendance===true?<Loading height={loadingHeight} color="#ff6247" page="Home"/>:

            <div>
              Overall Attendance
              <div className="TopColorHome">
                <img src={Green} height="18px" width="18px" alt="green" className="ColorImagesHome"/>
                Green (85-100) : {attendanceData[0]}
              </div>
              <div className="BotColorHome">
                <img src={Yellow} height="18px" width="18px" alt="yellow" className="ColorImagesHome"/>
                Yellow (75-84) : {attendanceData[1]}
              </div>
              <div className="BotColorHome">
                <img src={Red} height="18px" width="18px" alt="red" className="ColorImagesHome"/>
                Red (0-74) : {attendanceData[2]}   
              </div>
              {attendanceData[3]===0?"":
              <div className="BotColorHome">
                <img src={Grey} height="18px" width="18px" alt="grey" className="ColorImagesHome"/>
                Grey (Yet to start) : {attendanceData[3]}
              </div>}
            </div>
            }
          </div>

          <div
          className="TextPartHome">
            <div className="RotatedTextAttendanceHome">
              Attendance
            </div>
          </div>
        </Card>
        <div className="HomeBottomButtons">
          <NavigateButtonsModel navigateLink="idCard" heading="Id-Card" image={IdCardIcon} type="button"/>
          <Card
            raised
            className="NavigateButtonsModel"
            onClick={() => setOpenPopUp(o => !o)}
            >
                <img src={MarksIcon} height="40px" width="40px" alt="Image" className="ImageNavigateButtonsModel"/>
                <div className="IdCardTextHome">
                    Marks
                </div>
        </Card>
          {/* <NavigateButtonsModel navigateLink="marks" heading="Marks" image={MarksIcon} type="button" onClick={() => setOpenPopUp(o => !o)}/>     */}
        </div>

        <div className="HomeBottomButtons">
          <NavigateButtonsModel navigateLink="https://student.amizone.net/" heading="Open Amizone" image={AmizoneIcon} type="link"/>
          <NavigateButtonsModel navigateLink="https://sarwan-singh.github.io/" heading="Contact me" image={ContactIcon} type="link" onClick={()=>setOpenPopUp(true)}/>
        </div>

        <div className="AboutMeHome">
          <div>Developed By - Sarwan Singh</div>
          <div>B.Tech CSE (2017-2021)</div>
        </div>
            
      </div>
    </motion.div>
  );
}

export default Home;